export default __webpack_public_path__ + "static/media/player-transparent@0.5x.0c2ef90c.png";